import * as createFuncs from './create';
import * as getFuncs from './get';
import * as updateFuncs from './update';
import * as deployFuncs from './deploy';

export const projectService = {
  ...createFuncs,
  ...getFuncs,
  ...updateFuncs,
  ...deployFuncs
};
